import BankOutlined from '@ant-design/icons/BankOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import WarningOutlined from '@ant-design/icons/WarningOutlined'
import { Button, Empty, message, Popconfirm, Select, Tag, Tooltip } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { yellowPrimary } from '../../color'
import { ASSIGNEE_TYPE } from '../../constants'
import { AvatarHasName } from '../Common/Avatar'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import { ModalBody, ModalWrapper } from './SelectPeoplePopupStyled'
import SelectUserDepartmentBox from './SelectUserDepartmentBox'

const { Option } = Select

const defaultKeys = Array.from(Array(100).keys())

const SelectPeoplePopup = props => {
  const {
    id,
    isVisibleSelectPeoplePopup,
    handleSubmitSelectUser,
    handleCancelSelectUser,
    selectPeopleStore,
    authenticationStore,
    companyStore,
    onlyOneUser,
    onlySelectOne,
    disableSelectDepartment,
    noLoadSelectData,
    title,
    okText,
    cancelText,
    isOpenCollapse,
    allowChangeCompany,
    handleUpdateEmpty = () => {},
    isUserDisableList = true,
    setCheckSelectOne,
    checkSelectOne,
    isSendType, // dành riêng cho phần chọn người của văn bản đến, văn bản đi
    setIsSendType,
    checkCurrentUserAction,
  } = props

  const {
    selectPopupName,
    companyCode,
    assigneePopupType,
    selectUserData,
    setSelectUserData,
    selectDepartmentData,
    setSelectDepartmentData,
    setDepartmentWithUserList,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const [selectedList, setSelectedList] = useState([])
  const [userDisableList, setUserDisableList] = useState([])
  const [departmentDisableList, setDepartmentDisableList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [prevUserList, setPrevUserList] = useState([])
  const [prevDepartmentList, setPrevDepartmentList] = useState([])
  const [defaultActiveKey, setDefaultActiveKey] = useState(defaultKeys)
  const [checkCancel, setCheckCancel] = useState(false) // Nếu không có quyền thì không thể hủy chọn toàn bộ danh sách người, phòng ban đã gán

  const { companyList } = companyStore
  const showDropdownCompany = allowChangeCompany ?? true

  useEffect(() => {
    if (!assigneePopupType) return
    setPrevUserList(selectUserData[assigneePopupType])
    setPrevDepartmentList(selectDepartmentData[assigneePopupType])
  }, [isVisibleSelectPeoplePopup])

  useEffect(() => {
    if (noLoadSelectData) return
    ;(async () => {
      if (companyCode) {
        try {
          setIsLoading(true)
          await selectPeopleStore.getDepartmentWithUsers()
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        } finally {
          setIsLoading(false)
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedUserList = [
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...(selectUserData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectUserData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_kt_ktnb] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.nddpv_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.dvpt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.dv_cqvp_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectUserData[ASSIGNEE_TYPE.CREATE]
        : []),
      ...(selectUserData[ASSIGNEE_TYPE.tgd_ptgd] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_kt_ktnb_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.hdqt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_dieu_hanh] || []),
      ...(selectUserData[ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER] || []),
    ]

    const selectedDepartmentList = [
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...(selectDepartmentData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectDepartmentData[ASSIGNEE_TYPE.CREATE]
        : []),
    ]
    isUserDisableList &&
      setUserDisableList(
        selectedUserList
          .filter(
            el =>
              el.permission !== assigneePopupType &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_kt_ktnb &&
              el.permission !== ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc &&
              el.permission !== ASSIGNEE_TYPE.nddpv_vimc &&
              el.permission !== ASSIGNEE_TYPE.dvpt_vimc &&
              el.permission !== ASSIGNEE_TYPE.dv_cqvp_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc &&
              el.permission !== ASSIGNEE_TYPE.tgd_ptgd &&
              el.permission !== ASSIGNEE_TYPE.ban_kt_ktnb_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_dieu_hanh &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_vimc &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_ban
          )
          .map(el => el.id)
      )
    setDepartmentDisableList(
      selectedDepartmentList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    if (!assigneePopupType) return
    setSelectedList([
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ])
  }, [selectUserData, selectDepartmentData, assigneePopupType])

  const handleRemoveSelect = useCallback(
    item => {
      if (!assigneePopupType) return
      const removeItem = () => {
        setSelectUserData({
          ...selectUserData,
          [assigneePopupType]: selectUserData[assigneePopupType].filter(
            el => el.id !== item.id
          ),
        })
        setSelectDepartmentData({
          ...selectDepartmentData,
          [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
            el => el.id !== item.id
          ),
        })
      }

      const canRemove =
        !isSendType ||
        item.create_user === null ||
        item.create_user === authenticationStore.currentUser.username ||
        checkCurrentUserAction

      if (canRemove) {
        removeItem()
      } else {
        message.warning('Bạn không có quyền xóa người dùng này!')
        return
      }
    },
    [assigneePopupType, selectUserData, selectDepartmentData]
  )

  useEffect(() => {
    setDepartmentWithUserList(originDepartmentWithUserList)
  }, [isVisibleSelectPeoplePopup])

  const onCompanyChange = value => {
    console.log('onCompanyChange', value)

    // setSelectedList([])
    // selectPeopleStore.clearSelectedByType(assigneePopupType)
    selectPeopleStore.companyCode = value
  }

  const handleSubmit = () => {
    handleSubmitSelectUser()
    setDefaultActiveKey([])
    if (checkSelectOne) {
      setCheckSelectOne(false)
    }
    if (isSendType) {
      setIsSendType(false)
    }
  }

  return (
    <ModalWrapper
      maskClosable={false}
      okText={okText || 'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={800}
      style={{ top: 20 }}
      zIndex={1000}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          {showDropdownCompany ? (
            <Select
              // style={{ width: 200 }}
              notFoundContent={<EmptyContent />}
              onChange={onCompanyChange}
              value={companyCode}
              placeholder={'-- Chọn công ty --'}>
              {companyList.map(item => (
                <Option key={item.code} value={item.code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          ) : (
            <span>{title || selectPopupName}</span>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              alignItems: 'center',
            }}>
            {!checkCancel && isSendType ? null : (
              <>
                {disableSelectDepartment || cancelText ? (
                  <Popconfirm
                    placement="top"
                    title={
                      'Bạn có chắc chắn muốn xóa hết người được chọn không ?'
                    }
                    onConfirm={async () => {
                      selectPeopleStore.setSelectUserData({
                        ...selectUserData,
                        [assigneePopupType]: [],
                      })
                      handleUpdateEmpty()
                      // handleCancelSelectUser()
                    }}
                    okText="Đồng ý"
                    cancelText="Không"
                    zIndex={1600}>
                    <Button
                      danger
                      icon={
                        <WarningOutlined style={{ color: yellowPrimary }} />
                      }>
                      {cancelText || 'Hủy chọn'}
                    </Button>
                  </Popconfirm>
                ) : (
                  <Popconfirm
                    zIndex={2000}
                    placement="top"
                    title={
                      'Bạn có chắc chắn muốn xóa hết người được chọn không ?'
                    }
                    onConfirm={() => {
                      selectPeopleStore.handleRemoveSelectUserDepartment()
                    }}
                    okText="Đồng ý"
                    cancelText="Không">
                    <Button
                      danger
                      icon={
                        <WarningOutlined style={{ color: yellowPrimary }} />
                      }>
                      {cancelText || 'Hủy chọn'}
                    </Button>
                  </Popconfirm>
                )}
              </>
            )}

            <Button
              type={'primary'}
              onClick={() => {
                JSON.stringify(selectDepartmentData[assigneePopupType]) !==
                  JSON.stringify(prevDepartmentList) ||
                JSON.stringify(selectUserData[assigneePopupType]) !==
                  JSON.stringify(prevUserList)
                  ? handleSubmit()
                  : handleCancelSelectUser()
              }}>
              {okText || 'Đồng ý'}
            </Button>
            {!cancelText && (
              <div>
                {/* {disableSelectDepartment ? (
                  <Tooltip title={'Đóng'}>
                    <CloseOutlined onClick={handleCancelSelectUser} />
                  </Tooltip>
                ) : ( */}
                <Tooltip title={'Đóng'}>
                  <CloseOutlined
                    onClick={() => {
                      if (checkSelectOne) {
                        setCheckSelectOne(false)
                      }
                      setSelectUserData({
                        ...selectUserData,
                        [assigneePopupType]: prevUserList,
                      })
                      setSelectDepartmentData({
                        ...selectDepartmentData,
                        [assigneePopupType]: prevDepartmentList,
                      })
                      handleCancelSelectUser()
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      }
      closable={false}
      forceRender={true}
      footer={null}
      visible={isVisibleSelectPeoplePopup}>
      <ModalBody id={id}>
        <div
          style={{
            display: 'flex',
            gap: 4,
            paddingTop: 10,
          }}>
          <div style={{ flexGrow: 1 }}>
            <div className={'modal-body'} style={{ position: 'relative' }}>
              <SelectUserDepartmentBox
                isSendType={isSendType}
                defaultKeys={defaultKeys}
                defaultActiveKey={defaultActiveKey}
                setDefaultActiveKey={setDefaultActiveKey}
                isOpenCollapse={isOpenCollapse}
                isVisibleSelectPeoplePopup={isVisibleSelectPeoplePopup}
                disableSelectDepartment={disableSelectDepartment}
                onlyOneUser={
                  assigneePopupType === 'ban_kt_ktnb_vimc' ||
                  assigneePopupType === 'ban_dieu_hanh' ||
                  assigneePopupType === 'hdqt_vimc'
                    ? !onlyOneUser
                    : onlyOneUser
                }
                onlySelectOne={onlySelectOne}
                userDisableList={userDisableList}
                departmentDisableList={departmentDisableList}
                selectedList={selectedList}
                setCheckCancel={setCheckCancel}
              />
              <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoading}
                noBackground
              />
            </div>
          </div>
          <div
            className={'selected-list'}
            style={{
              flex: '0 0 250px',
              maxHeight: 'calc(100vh - 111px)',
              overflowY: 'auto',
              maxWidth: 250,
              backgroundColor: '#fff',
              margin: '-10px 0 -15px 0',
              borderLeft: '1px solid #f0f0f0',
              padding: '15px 10px',
            }}>
            <div
              style={{
                margin: '-15px -10px 10px -10px',
                padding: 15,
                borderBottom: '1px solid #f0f0f0',
                fontWeight: 500,
                backgroundColor: '#e9f7ff',
              }}>
              Danh sách đã chọn:
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
              }}>
              {Array.from(new Set(selectedList.map(el => el.id))).map(id => {
                const el = selectedList.find(item => item.id === id)
                return (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )
                      }
                    />
                  </Tag>
                )
              })}
              <Empty
                style={{ width: '100%' }}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}

SelectPeoplePopup.propTypes = {}

export default inject(
  'selectPeopleStore',
  // 'loadingAnimationStore',
  'companyStore',
  'authenticationStore'
)(observer(SelectPeoplePopup))
